<template>
    <v-row no-gutters class="mb-1">
        <v-col cols="12" md="8" class="pe-1">
            <v-autocomplete
                label="Item"
                v-model="line.item_id"
                :items="items"
                :loading="itemsLoading"
                item-text="display_name"
                item-value="id"
                :rules="[isRequired]"
                @update:search-input="$emit('update:items-search-input', $event)"
                dense
                outlined
                hide-details
            >
            </v-autocomplete>
        </v-col> 
        <v-col cols="12" md="2" class="pe-1">
            <v-text-field
                label="Quantity"
                v-model="line.quantity"
                :rules="[isRequired, isNumeric]"
                dense
                outlined
                hide-details
            >
            </v-text-field>
        </v-col>
        <v-col cols="12" md="2" class="d-flex">
            <v-autocomplete
                label="Unit"
                v-model="line.measure_unit_id"
                :rules="[isRequired]"
                :items="measureUnits"
                item-text="abbreviation"
                item-value="id"
                dense
                outlined
                hide-details
            >
            </v-autocomplete>
            <v-btn icon @click="handleDeleteLine">
                <v-icon>
                    mdi-close
                </v-icon>
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
import { isRequired, isNumeric} from "../../../utils/validations"
export default {
    props: {
       value: Object,
       items: Array,
       itemsLoading: Boolean
    },
    data() {
        return {
            line: {
                item_id: null,
                quantity: null,
                measure_unit_id: null
            },
            measureUnits: []
        }
    },
    watch: {
        line: {
            handler(line) {
                this.$emit("input", {...line, base_quantity: this.baseQuantity});
            },
            deep: true
        },
        item: {
            handler(item) {
                if(!item) {
                    this.measureUnits = [];
                    return;
                }
                if(Array.isArray(item.measure_units)) {
                    this.measureUnits = item.measure_units;
                    return;
                }
                this.measureUnits = [];
            }
        }
        
    },
    methods: {
        isRequired,
        isNumeric,
        handleDeleteLine() {
            this.$emit("deleteLine")
        }
    },
    computed: {
        item() {
            return this.items.find(e => e.id == this.line.item_id)
        },
        // TODO: should be calculated using measure unit conversion.
        baseQuantity() {
            return this.line.quantity
        }
    },
    created() {
        if(this.value) {
            this.line = {...this.line, ...this.value}
        }
    }
}
</script>

<style>

</style>